import React, { useState } from "react";
import {
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  RespFont,
} from "../../../common/Style";
import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import OWC from "../OWC";
import { useSelector } from "react-redux";
import dropdown from "../../../../assets/common/dropdown.svg";
import { toast } from "react-toastify";

const Connection = ({ func, init }) => {
  const { user } = useSelector((state) => state.authReducer);

  const [inviting, setInviting] = useState("");
  const [owc, setOwc] = useState("קשר");
  const [showDropOwc, setShowDropOwc] = useState(false);
  const defaultPreSms1 = `${user.brideFN + " " + user.brideLN} ו${
    user.groomFN + " " + user.groomLN
  } שמחים להזמינכם לחתונתם!`;

  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <OverlayTrigger
          placement={"top"}
          overlay={<Tooltip>{"הקשר של בעל/ת השמחה למזמין"}</Tooltip>}
        >
          <GenericDiv
            background={"#7b96c4"}
            style={{
              position: "relative",
              height: "30px",
              padding: "19.5px 10px",
              marginTop: "7px",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setShowDropOwc(!showDropOwc);
            }}
          >
            <div>{owc}</div>
            <img
              src={dropdown}
              alt={"dropdown"}
              style={{ width: "25px", marginLeft: "-7px" }}
            />
            {showDropOwc && (
              <OWC setOwc={setOwc} setShowDropOwc={setShowDropOwc} />
            )}
          </GenericDiv>
        </OverlayTrigger>
        <Label style={{ marginTop: "30px" }}>מזמין</Label>
        <Input
          onChange={(e) => setInviting(e.target.value)}
          placeholder="כתבו כאן..."
        />

        <FlexRowBetween
          style={{ width: "90%", margin: "0 auto", marginBottom: "20px" }}
        >
          <RespFont>
            {inviting !== "" && owc !== "קשר" ? (
              inviting +
              (owc[owc.length - 1] === "ם"
                ? " שמחים"
                : owc[owc.length - 1] === "ו"
                ? " שמח"
                : " שמחה") +
              " להזמינכם לחתונת " +
              owc +
              (owc.includes("ת") ? ` ${user.brideFN}.` : ` ${user.groomFN}.`)
            ) : (
              <>ברירת מחדל: {defaultPreSms1}</>
            )}
          </RespFont>
        </FlexRowBetween>
        <GenericDiv
          onClick={() => {
            if (
              (inviting !== "" && owc !== "קשר") ||
              (inviting === "" && owc === "קשר")
            )
              func({ inviting, owc }, init);
            else
              toast.warning(
                "שני השדות מלאים או ריקים, לא אפשרי למלא רק שדה אחד"
              );
          }}
          style={{ margin: "10px auto", marginTop: "30px" }}
        >
          שמירה
        </GenericDiv>
      </div>
    </PopupForm>
  );
};

export default Connection;
